module.exports = __webpack_public_path__ + "media/images/helpbubble-4804f36b510ff2e0d6bbf244262ce32c.png";